export {
    AgentAPi,
    Auth
}


//const url = 'https://intranet-api-test.movileuros.com/';

// quito dominio softenjerez
//const url = 'https://api-intranet.softenjerez.es/';
const url = 'https://api-intranet.movileuros.com/';


//const url = 'http://intranet_backend.com/';
//const url = 'https://api-intranet.mundorecarga.es/'

const Auth = {
    login: url + 'api/login',
    send2FACode: url + 'api/send2FACode',
    check2FA: url + 'api/check2FA',
}


const AgentAPi = {
    showHome: url,
    showAgentHome: url + 'api/agents',
    showSellerHome: url + 'api/seller',
    showRessellerHome: url + 'api/reseller',
};














